import React from "react";
import * as styles from "./velavu-notice-body.module.scss";
import { classArr } from "../../helper/style-helper";

export type VelavuNoticeBodyVariant = "small" | "large";

export interface VelavuNoticeBodyProps {
	children?: React.ReactNode;
	variant?: VelavuNoticeBodyVariant;
}

export default function VelavuNoticeBody(props: VelavuNoticeBodyProps) {
	const variant: VelavuNoticeBodyVariant = props.variant ?? "small";

	return (
		<p
			className={classArr(
				styles.body,
				variant === "small" ? styles.bodySmall : styles.bodyLarge,
			)}
		>
			{props.children}
		</p>
	);
}
